import React, { createContext, useReducer, useEffect } from "react";
import reducer from "./reducer";
import { Actions, State, ReadUser } from "./types";


type Props = {
  children: React.ReactNode;
};

type Dispatch = React.Dispatch<Actions>;

const defaultState = {
  sidebarState: false,
  userId: 0,
  userEmail: "",
  userName: "",
  userNickname: "",
  userType: -1,
  userStudentNumber: "",
  language: localStorage.getItem('selectedLanguage') || 'ja',
};

const localStorageKey = 'naruto_readUser';

// `readUser`がリロードによって初期化されないための処理
// `readUser`だけをlocalStorageから読み込む処理
const loadInitialState = (): State => {
  let persistedReadUser: ReadUser | null = null;
  
  try {
    // `readUser`専用のキーでlocalStorageから値を取得
    const savedReadUser = localStorage.getItem(localStorageKey);
    if (savedReadUser) {
      // 保存されたデータ（JSON文字列）をパースする
      persistedReadUser = JSON.parse(savedReadUser);
    }
  } catch (error) {
    // console.error("Failed to parse readUserId from localStorage", error);
  }

  // localStorageから読み込んだ値を結合して最終的な初期Stateを生成
  return {
    ...defaultState,
    readUser: persistedReadUser,
  };
};

export const initialState: State = loadInitialState();

export const Store = createContext<{ state: State; dispatch: Dispatch }>({
  state: initialState,
  dispatch: () => null,
});
const { Provider } = Store;

export default function StateProvider(props: Props) {
  const [state, dispatch] = useReducer(reducer, initialState);
  
  // `readUser`がリロードによって初期化されないための処理
  // `readUser`が変更されたときだけ、localStorageに保存する
  useEffect(() => {
    // `state.readUser`だけをJSON文字列に変換して保存
    localStorage.setItem(localStorageKey, JSON.stringify(state.readUser));
  }, [state.readUser]); // 依存配列を`state.readUser`に限定する

  return <Provider value={{ state, dispatch }}>{props.children}</Provider>;
}
